import {Resource, ResourceCollection} from 'simpli-web-sdk'
import {NoneResource} from '@/model/NoneResource'
import {TipoResponsavelUsuario} from '@/enums/TipoResponsavelUsuario'

export class TipoResponsavelUsuarioCollection {
  options() {
    const values = Object.values(
      TipoResponsavelUsuario
    ).filter((item: string | TipoResponsavelUsuario) =>
      isNaN(parseInt(String(item)))
    )

    return new ResourceCollection(
      NoneResource,
      values.map(
        (tipo: string | TipoResponsavelUsuario, index: number) =>
          ({
            $id: index + 1,
            $tag: tipo,
          } as Resource)
      )
    )
  }
}
